/**
 * Recent documents dashboard component
 *
 */

/**
 * React
 */
import * as React from 'react';
import { Link } from '@fluentui/react/lib/Link';

import { ICommunity } from '../../types';

interface IProps {
  community?: ICommunity;
  showTeams: boolean;
  showSharepoint: boolean;
  constants: any;
  isProtected: boolean;
  govTeamsLogo: any;
}

const QuickLaunchComponent = (props: IProps) => {
  const { community, showTeams, showSharepoint , constants, isProtected, govTeamsLogo } = props;
  return (
    <div className='dashboard-quickLaunch'>

      {(!community && !isProtected) && (
        <Link
          className='quickLaunch-item'
          href={!community ? constants.WAFFLE_GOVTEAMSAPP : community.url}
          target='_blank'
        >
          <img className='item-icon-govteamsapp' src={govTeamsLogo} alt='GovTEAMS Logo' />

          <div className='item-text-govteamsapp'>
            <h3>GovTEAMS App</h3>
            <div style={{ fontWeight: 400 }}>
              Stay connected with the latest news
            </div>
          </div>
        </Link>
      )}

      {!community && isProtected && (
        <Link
          className='quickLaunch-item'
          href={
            !community ? constants.WAFFLE_OUTLOOK : community.url
          }
          target='_blank'
        >
          <div className='item-icon item-icon-outlook' />
          <div className='item-text'>
            <h3>Outlook</h3>
            <div style={{ fontWeight: 400 }}>
              Send and receive emails up to PROTECTED
            </div>
          </div>
        </Link>
      )}

      {(!community || showTeams) && (
        <Link
          className='quickLaunch-item'
          href={!community ? constants.WAFFLE_TEAMS : community.url}
          target='_blank'
        >
          <div className='item-icon item-icon-teams' />
          <div className='item-text'>
            <h3>Teams</h3>
            <div style={{ fontWeight: 400 }}>
              Connect and work with your team
            </div>
          </div>
        </Link>
      )}

      {(!community || showSharepoint) && (
        <Link
          className='quickLaunch-item'
          href={
            !community ? constants.WAFFLE_SHAREPOINT : community.sharePointUrl
          }
          target='_blank'
        >
          <div className='item-icon item-icon-sharepoint' />
          <div className='item-text'>
            <h3>SharePoint</h3>
            <div style={{ fontWeight: 400 }}>
              Broadcast news, files and information
            </div>
          </div>
        </Link>
      )}
    </div>
  );
}

export default QuickLaunchComponent;
